import React from "react";
import editIcon from "../assets/icons/edit.png";
import deleteIcon from "../assets/icons/delete.png";
import blockIcon from "../assets/icons/block.png";
import unblockIcon from "../assets/icons/unblock.png"; 

const TableBtns = ({
  onClickEdit,
  onClickDelete,
  onClickBlock,        
  deleteloading = false,
  editloading = false,
  blockloading = false, 
  isBlocked ,    
  deletebtn = true,
  editbtn = true,
  blockbtn      
}) => {
  return (
    <>
      {editbtn && (
        <>
          {editloading ? (
            <i className="fa-solid fa-fan fa-spin fa-spin-reverse me-2"></i>
          ) : (
            <img
              src={editIcon}
              onClick={onClickEdit}
              className="cursor-pointer"
              alt="editIcon"
            />
          )}
        </>
      )}
      {deletebtn && (
        <>
          {deleteloading ? (
            <i className="fa-solid fa-fan fa-spin fa-spin-reverse me-2"></i>
          ) : (
            <img
              src={deleteIcon}
              onClick={onClickDelete}
              className="cursor-pointer"
              alt="deleteIcon"
            />
          )}
        </>
      )}
      {blockbtn && (
        <>
          {blockloading ? (
            <i className="fa-solid fa-fan fa-spin fa-spin-reverse me-2"></i>
          ) : isBlocked ? (
            <img
              src={unblockIcon}
              onClick={onClickBlock}
              className="cursor-pointer"
              alt="unblockIcon"
            />
          ) : (
            <img
              src={blockIcon}
              onClick={onClickBlock}
              className="cursor-pointer"
              alt="blockIcon"
            />
          )}
        </>
      )}
    </>
  );
};

export default TableBtns;
